/**
 * Web stand-in for the deep import 'react-native-popover-view/dist/Popover'.
 *
 * About thirty screens import the Popover class from that path instead of the
 * package root, so the `react-native-popover-view$` alias - and with it
 * popoverView.web.tsx - never sees them. Among them are the confirmation
 * dialogs that were given no width (logout, sort options, add/edit option,
 * the order list's delete-filter prompt, ...), which on web collapsed to a
 * ~210px column.
 *
 * This wrapper is deliberately thinner than popoverView.web.tsx: it applies
 * only the confirmation-dialog width and passes everything else through
 * untouched. Routing these screens through the full wrapper would also give
 * them its min/max width, radius, overflow clipping and backdrop - a visual
 * change to every popover on thirty screens, not the fix that was asked for.
 *
 * webpack aliases the exact specifier to this file for the web build only;
 * Metro never resolves it, so Android and iOS keep the real class.
 */

import React from 'react';
import {useWindowDimensions} from 'react-native';
/*
 * `/dist/index` does not match either popover alias, so this reaches the real
 * library rather than recursing into a wrapper.
 */
import BasePopover from 'react-native-popover-view/dist/index';
import type {PublicPopoverProps} from 'react-native-popover-view/dist/Popover';

import {confirmationWidth} from './popoverView.web';

const PopoverDialog = ({popoverStyle, children, ...props}: PublicPopoverProps) => {
  const {width} = useWindowDimensions();
  const dialogWidth = confirmationWidth(children, popoverStyle, width);

  return (
    <BasePopover
      {...props}
      popoverStyle={dialogWidth ? [popoverStyle, {width: dialogWidth}] : popoverStyle}>
      {children}
    </BasePopover>
  );
};

export default PopoverDialog;
